import { render, staticRenderFns } from "./sales-report-chart.vue?vue&type=template&id=c2c2629c&"
import script from "./sales-report-chart.vue?vue&type=script&lang=ts&"
export * from "./sales-report-chart.vue?vue&type=script&lang=ts&"
import style0 from "./sales-report-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports